import { SITE_URL, homePath } from './seoConfig';
import core from './schemaCore';

export const organizationSchema = (lang, t) =>
  core.organizationSchema({ orgDescription: t('seo.orgDescription'), services: t('seo.services', { returnObjects: true }) });

export const personSchema = () => core.personSchema({});

export const websiteSchema = () => core.websiteSchema();

export const webPageSchema = (lang, path, title, description, type = 'WebPage') =>
  core.webPageSchema(lang, path, title, description, type);

export const breadcrumbSchema = (lang, t, items) => core.breadcrumbSchema(lang, t('nav.home'), items);

export const softwareAppSchema = (project, url) => core.softwareAppSchema(project, url);

export const buildGraph = core.buildGraph;

export { SITE_URL, homePath };
